import { connect } from 'react-redux';
import { removeNotice } from './actions';
import NoticeStack from './NoticeStack';

const mapStateToProps = (state) => ({
  theme: state.getIn(['components', 'noticeStack', 'theme']),
});

export default connect(mapStateToProps, { removeNotice })(NoticeStack);
